export default "__VITE_ASSET__Dij_bfE1__"